export default "__VITE_ASSET__DSyvqCH5__"